<template>
  <div class="null_container">
    <div style="width: 100%;">
      <span class="null_ico null_ico5" ></span>
      <div class="null_txt">暂无数据哦~</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'show-no-data',
    props: []
  }
</script>

<style scoped>
  .null_container {
    height: 100%;
    display: flex;
    align-items: center; /*定义body的元素垂直居中*/
    justify-content: center; /*定义body的里的元素水平居中*/
  }
  .null_ico {
    display: block;
    width: 113px;
    height: 92px;
    margin: 0 auto 10px;
    padding-top: 20px;
  }
  .null_ico5 {
    background: url(../static/images/null6.png) center no-repeat;
  }
  .null_txt {
    height: 35px;
    line-height: 35px;
    font-family: "\5FAE\8F6F\96C5\9ED1";
    font-size: 14px;
    text-align: center;
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// src/custom/components/page/analyse/show/show-no-data.vue